import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import useLocale from '@/util/locale';


export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
	place: {
		type: String,
		required: true
	}
},
  setup(__props) {



const { selectedLocaleId } = useLocale();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: "logo",
    src: require(`@/assets/img/${_unref(selectedLocaleId)}/logo-${__props.place}.svg`)
  }, null, 8, _hoisted_1))
}
}

})